              <!-- ***************SG-4637 start  ******************* -->

 <mat-card fxLayout="column" fxFlex="100%" style="padding: 4px;" class="mat-elevation-z8 av-loader-host">
    <div class="av-loader-overlay" *ngIf="avLoader.loading$ | async">
        <mat-spinner diameter="36"></mat-spinner>
    </div>
    <mat-card-subtitle cardHeader style="padding-top: 7px;">

        <div class="export-icon"> <span class="mission-heading">Mission Records</span>

            <!-- <i class="fa fa-share-square-o" aria-hidden="true"
                style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                (click)="exportCsvData('performance')"></i> -->
        </div>
       
    </mat-card-subtitle>
   
        <div class="table-class">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" width="100%">
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header width="22%"> Name </th>
                    <td mat-cell *matCellDef="let element"style="text-align: justify" [matTooltip]="element.title" pointer >
                        <a class="underline" (click)="missionLevelData(element)">  {{element.title}} </a></td>
                </ng-container>
                <ng-container matColumnDef="sessionsPlayed">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Sessions </th>
                    <td mat-cell *matCellDef="let element" [matTooltip]="element.sessionsPlayed" pointer>
                         {{element.sessionsPlayed}} </td>
                </ng-container>
                <ng-container matColumnDef="clearedSessionCount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header width="12%"> Cleared </th>
                    <td mat-cell *matCellDef="let element" [matTooltip]="element.clearedSessionCount" pointer>
                        {{element.clearedSessionCount}} </td>
                </ng-container>
                <ng-container matColumnDef="failedCount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Not Cleared </th>
                    <td mat-cell *matCellDef="let element" [matTooltip]="element.failedCount" pointer>
                        {{element.failedCount}} </td>
                </ng-container>
                <ng-container matColumnDef="percentageCompleteMission">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> % Correct </th>
                    <td mat-cell *matCellDef="let element" [matTooltip]="element.percentageCompleteMission" pointer>
                        {{element.percentageCompleteMission}}% </td>
                </ng-container>
                <ng-container matColumnDef="separationViolation">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header width="22%" class="sep-violation-col"> Separation Violations </th>
                    <td mat-cell *matCellDef="let element" [matTooltip]="element.separationViolation" pointer>
                        {{element.separationViolation}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" pointer></tr>
            </table>
        </div>
        <mat-paginator [pageSizeOptions]="[5,10, 25, 50]" [pageSize]="pageSize" [length]="missionRecords && missionRecords.length"
                (page)="onPageChange($event)"></mat-paginator>
</mat-card> 
             <!-- ***************SG-4637 end  ******************* -->
